import { Routes } from '@angular/router';
import { loggedInGuard } from './core/guards/logged-in-guard';
import { loggedOutGuard } from './core/guards/logged-out-guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
    canActivate: [loggedOutGuard],
  },
  {
    path: '',
    loadChildren: () =>
      import('./features/main/main.routes').then((m) => m.MAIN_ROUTES),
    canActivate: [loggedInGuard],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
